<template>
    <div class="pushProject">
        <leftnav class="fl" :mkcode="yj_mkcode" :itemcode="yj_itemcode" docutitle="共享项目"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
                        <span class="current title">共享项目<em>({{total}})</em></span>
                    </div>
                </div>
                <div class="enterprise_list_box whitebox">
                    <div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
                    </div>
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>项目名称</th>
                                <th>投资额(亿元)</th>
								<th>年产值(亿元)</th>
								<!-- <th>企业名称</th> -->
								<th>产业类型</th>
                                <!-- <th>项目状态</th> -->
                                <th>预匹配市州</th>
                                <th>备注</th>
								<!-- <th>评估状态</th> -->
								<th>项目类型</th>
								
                                <!-- <th>推送状态</th> -->
                                 <th >推送给目标单位</th>
							</tr>
                            <tr v-for="item in enterpristlist" :key="item.stockcode">
                                <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" class="title">{{item.project}}</td>
                                <!-- <td>{{item.companyName}}</td> -->
                                 <td>{{item.amount || '-'}}</td>
                                <td>{{item.outputValue || '-'}} </td>
                                <td>{{item.smallClassText || '-'}}</td>
                                <td>{{item.assessmentDetail.city || '-'}}</td>
                                <td>{{item.remark || '-'}}</td>
                                <!-- <td>{{item.assessmentText || '-'}}</td> -->
                                <td>{{item.projectTypeText || '-'}}</td>
                                
                                <!-- <td>{{item.pushText || '-'}}</td> -->
                                 <td class="text-left"><p>主送：{{item.pushDetail.mainUnitText || '-' }}</p><p>抄送：{{ item.pushDetail.secondUnitText || '-' }}</p></td>
                                
                            </tr>
                    </table>
                </div>
                <div class="centerpage1 company_pagelist" v-show="totalPage>1">
                    <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                        v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'pushProject',
    data() {
        return {
            currentTab: '3',
            userdata: {},
            tabList: [
                { value: '3', text: '未推送项目',  num:0, itemcode:'F-wtsxm' },
                { value: '4', text: '已推送项目',  num:0 , itemcode:'F-ytsxm' },
                { value: '5', text: '已接收项目',  num:0 ,itemcode:'F-yjsxm' },
            ],
            yj_mkcode: 'G',
            yj_itemcode: 'G-gxxm',
            enterpristlist: [],
            recipientList: [],
            temdialogData: {},
            projectTypeList: [],
            form: {
                receiveUser: '',
                projectType: '',
                keepself: false,
                mainUnit: '',//主送
                secondUnit: '',//抄送
                showFileList: true,
                file: [],
                remark: '',
            },
            isInitiate: false,
            temProjectType: '',
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            mainUnitList:[],
            secondUnitList: [],
        }
    },
    computed: {
        ...mapState({ isCollapse: (state) => state.isCollapse,}),
        ...mapGetters(['isCollapse'])
    },

    components: {
    },
    mounted() {
            this.ajaxsearchcompany(1);
            this.getProjectTypeList(); // 获取项目类型列表
            this.getRecipientList(); // 获取接收人列表
            this.getMainUnitList(1);
            this.getMainUnitList(2);
    },
    created() {
        this.userdata = this.getuseriformation();
        this.currentTab = this.$route.query.type;
        let currentTabItem = this.tabList.find(item => item.value == this.currentTab);
            if (currentTabItem) {
                this.yj_itemcode = currentTabItem.itemcode;
            }
    },
     //监听路由变化
    watch: {
        $route: function (newVal, oldVal) {
            this.currentTab = this.$route.query.type;
        let currentTabItem = this.tabList.find(item => item.value == this.currentTab);
            if (currentTabItem) {
                this.yj_itemcode = currentTabItem.itemcode;
            }
            this.ajaxsearchcompany(1);
        }
    },
    methods: {
        //获取主送列表
        getMainUnitList(type){
            let ajaxurl = this.$api.crm.Unit.list()+'?type='+type;
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then((res) => {
                if (res.data.success) {
                    if(type==1){this.mainUnitList = res.data.list;}
                    if(type==2){this.secondUnitList = res.data.list;}
                }
            })
        },
        /**
         * 项目类型改变
         * @param {Number} value - 选中的项目类型值
         */
        hanlderClass(value) {
            console.log("项目类型改变", value);
            this.temProjectType = Number(value); // 保持为 Number，
            
        },
        /**
		 * 关闭发起推送弹框
		 */
        closeDialog() {
            this.isInitiate = false;
            this.form = {
                recipient: '',
                projectType: '',
                keepself: false,
                mainUnit: '',//主送
                secondUnit: '',//抄送
                showFileList: true,
                file: null,
                remark: '',
            };
        },
		/**
		 * 文件删除回调
		 * @param {Object} file - 被删除的文件
		 * @param {Array} fileList - 文件列表
		 */
        handleRemove(file, fileList) {
			// console.log(file, fileList);
			this.deleteFile(file.id).then((res) => {
				console.log('删除成功31232131231233');
				this.project.file = fileList; // 更新文件列表 
			})

			console.log(file, fileList);
		},

		/**
		 * 文件预览回调
		 * @param {Object} file - 需要预览的文件
		 */
		handlePreview(file) {
			window.open(file.url);
		},        /**
         * 文件删除之前回调
         * @param {Object} file - 要删除的文件
         * @param {Array} fileList - 文件列表
         */
        beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${file.name}？`);
		},
        /**
         * 文件上传数量超出限制回调
         * @param {Object} files - 上传的文件
         * @param {Object} fileList - 上传的文件列表
         */
        handleExceed(files, fileList) {
			this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
        /**
         * 文件上传成功回调
         * @param {Object} res - 上传结果
         * @param {Object} file - 上传的文件
         * @param {Array} fileList - 上传的文件列表
         */
        handleAvatarSuccess(res, file, fileList) {
			this.form.file = fileList; // 更新文件列表
			console.log(res, file);
		},
         //详情页跳转
        detailrouterto(path, id) {
            if (id == 0 || id == "") {
                return;
            }
            this.routerlinkarry(path, { id: id });
        },
        //获取项目类型列表
        getProjectTypeList(){
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl = this.$api.crm.parameter.projectType();
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                if (res.data.success) {
                    let datalist = res.data.list;
                    _this.projectTypeList = datalist;
                    _this.bus.$emit('loading', false);
                }
            })
        },
        getRecipientList(){
            // 获取接收人列表
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl = this.$api.crm.user.pushList();
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                if (res.data.success) {
                    let datalist = res.data.list;
                    _this.recipientList = datalist;
                    _this.bus.$emit('loading', false);
                }
            })
        },
        closeInitiate() {
            this.isInitiate = false;
        },
        submitInitiate() {
           let fileD = '';
           for(let i = 0; i < this.form.file.length; i++){
               fileD = this.form.file[i].raw;
           }
           let formData = new FormData();
           if(this.temProjectType == 1){
               formData.append('mainUnit', this.form.mainUnit);
                formData.append('secondUnit', this.form.secondUnit);
           }else if(this.temProjectType == 2){
               formData.append('mainUnit', this.form.secondUnit);
               formData.append('secondUnit', '');
           }else if(this.temProjectType == 3){
               formData.append('mainUnit', '');
               formData.append('secondUnit', '');
           }
           formData.append('customerId', this.temdialogData.id);
        //    formData.append('keepself', this.form.keepself ? 1 : 0);
           formData.append('receiveUser', this.form.receiveUser);
           formData.append('projectType', this.form.projectType);
            formData.append('file', fileD);
            formData.append('remark', this.form.remark);
            // 打印 FormData 内容（调试用）
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }
            let that = this;
            let ajaxurl = this.$api.crm.push.post();
            console.log("提交数据", this.form, this.temProjectType);
            if(this.form.projectType<=0){
                this.$message.warning('请选择项目类型');
                return;
            }
            $.ajax({
                type: "post",
                url: ajaxurl,
                headers: {
                    AuthToken: this.userdata.token
                },
                data:formData,
                processData: false,  // 重要：不要让 jQuery 处理数据
                contentType: false,  // 重要：不要让 jQuery 设置内容类型
                success: function (res) {
                    if (res.success) {
                        that.$message({
                            message: '提交成功',
                            type: 'success'
                        })
                        that.isInitiate = false;
                    } else {
                        that.$message.error(res.msg);
                    }
                },
            });
        },
        //发起项目评估弹框
        initiatePopup(item) {
            
            this.temdialogData = item;
            this.temProjectType = Number(item.projectType);
            this.isInitiate = true;
            console.log("发起项目评估", item,this.temProjectType);
        },
        ajaxsearchcompany(page) {
            this.page = page || 1;
            // 获取项目列表
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl1 = this.$api.crm.project.list()+'?page='+this.page+'&pageSize='+this.pageSize+'&menu=16';
            this.$axios.get(ajaxurl1, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {

                console.log("项目列表", res.data);
                if (res.data.success) {
                    _this.enterpristlist = res.data.list;
                    _this.pageSize = res.data.pageSize//每一页显示的数据条数
                    _this.total = res.data.totalRecord//每一页显示的数据条数
                    _this.totalPage = res.data.totalPage//每一页显示的数据条数

                } else {
                    _this.$message.error(res.data.msg);
                }
                    _this.bus.$emit('loading', false);

            }).catch(function (err) {
                console.log(err);
            });
        },
        pageHandler: function(page) {
				this.ajaxsearchcompany(page);
			},
    }
}
</script>

<style scoped lang="scss">
.enterprise_list_box{
    min-height: 75vh;
}
.initiate_box{
    font-size: 16px;
    width: 85%;
    margin: 0 auto;
    ::v-deep{
        &.el-select{
            width: 100%;
        }
    }
}
.initiate_title{
    font-weight: 600;
}
.initiate_box_dialog{
    border-radius: 10px;
}
</style>